export class FileImportTO {
    public id: number;
    public formId: number;
    public formName: string;
    public model: string;
    public worksheetIndex: number;
    public processKey: string;
}
